/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'tools-share': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M14.375 12.5a3.125 3.125 0 00-2.431 1.181l-4.569-2.856a2.787 2.787 0 000-1.65l4.569-2.856a3.125 3.125 0 10-.694-1.944c.003.28.045.557.125.825L6.806 8.056a3.125 3.125 0 100 3.888l4.569 2.856c-.08.268-.122.546-.125.825a3.125 3.125 0 103.125-3.125zm0-10a1.875 1.875 0 110 3.75 1.875 1.875 0 010-3.75zm-10 9.375a1.875 1.875 0 110-3.75 1.875 1.875 0 010 3.75zm10 5.625a1.875 1.875 0 110-3.75 1.875 1.875 0 010 3.75z"/>'
  }
})
